import {IBizCoupon, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {ACoupon} from "@/views/editor/service/coupon/coupon";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export default class Coupon extends ACoupon implements IBizCoupon {

    subs: CheckboxOptionType[] = [{
        value: 'preheating', label: '预热优惠券', onChange(e) {
            console.log(e)
        }
    }];

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    resetMeta(): IBusiness {
        this.meta.subs.length = 0
        this.meta.subs.push(...this.subs.map(s => s.value as string));
        return this;
    }

    set(owner: string, coupons: unknown[]) {
        //
    }
}